module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-content fadeInRight animated tabBox",
    attrs: {
      "id": "org"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "ibox-content",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "search"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("机构名称")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.orgName),
      expression: "orgName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.orgName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orgName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("联系人")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.orgPerson),
      expression: "orgPerson",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.orgPerson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orgPerson = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.orgTel),
      expression: "orgTel",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.orgTel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orgTel = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("机构地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.orgAdd),
      expression: "orgAdd",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.orgAdd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orgAdd = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group "
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [(_vm.permission.indexOf('organiseList_select') == -1) ? _c('button', {
    staticClass: "btn btn-primary ",
    on: {
      "click": _vm.startToSearch
    }
  }, [_vm._v("查询")]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('organiseList_reset') == -1) ? _c('button', {
    staticClass: "btn btn-primary ",
    on: {
      "click": _vm.resetToInit
    }
  }, [_vm._v("重置")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "hr-line-dashed"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [(_vm.permission.indexOf('organiseList_add') == -1) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin > 0),
      expression: "isAdmin>0"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.openModal('new')
      }
    }
  }, [_vm._v("添加新机构")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover module_table",
    staticStyle: {
      "min-width": "1600px"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', [_vm._v("组织机构名称")]), _vm._v(" "), _c('th', {
    staticClass: "hand",
    on: {
      "click": function($event) {
        return _vm.reorder('orderNo')
      }
    }
  }, [_vm._v("顺序号"), _c('a', {
    staticClass: "icon_sort",
    class: [_vm.orderClicked ? 'sort_top' : 'sort_bottom']
  })]), _vm._v(" "), _c('th', {
    staticClass: "hand",
    on: {
      "click": function($event) {
        return _vm.reorder('status')
      }
    }
  }, [_vm._v("状态"), _c('a', {
    staticClass: "icon_sort",
    class: [_vm.statusClicked ? 'sort_top' : 'sort_bottom']
  })]), _vm._v(" "), _c('th', [_vm._v("联系人")]), _vm._v(" "), _c('th', [_vm._v("联系电话")]), _vm._v(" "), _c('th', [_vm._v("机构管理方")]), _vm._v(" "), _c('th', [_vm._v("组织机构地址")]), _vm._v(" "), _c('th', [_vm._v("备注")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "list-complete",
      "tag": "tbody"
    }
  }, _vm._l((_vm.orgList), function(orgInfo, index) {
    return _c('tr', {
      key: index + 'organiselist',
      staticClass: "list-complete-item"
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(orgInfo.customerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(orgInfo.orderno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(orgInfo.isenable === 1 ? '启用' : '禁用'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(orgInfo.linkman))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(orgInfo.telephone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(orgInfo.customerId == _vm.groupId ? '' : orgInfo.parentName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(orgInfo.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(orgInfo.memo))]), _vm._v(" "), _c('td', {
      staticClass: "table-btns text-center"
    }, [(_vm.permission.indexOf('organiseList_detail') == -1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.openModal('detail', index)
        }
      }
    }, [_vm._v("详情 ")]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('organiseList_edit') == -1) ? _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAdmin == 9 || (_vm.isAdmin > 0 && (orgInfo.levv - _vm.orgList[0].levv) < 2)),
        expression: "isAdmin==9||(isAdmin>0 &&(orgInfo.levv-orgList[0].levv)<2)"
      }],
      ref: "editBtn",
      refInFor: true,
      staticClass: "editBtn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openModal('edit', index)
        }
      }
    }, [_vm._v(" 编辑 ")]) : _vm._e(), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAdmin == 9 && (orgInfo.levv - _vm.selfOrgInfo.levv) != 0),
        expression: "isAdmin==9 && (orgInfo.levv-selfOrgInfo.levv)!=0"
      }],
      on: {
        "click": function($event) {
          return _vm.removeItem(orgInfo.customerId)
        }
      }
    }, [_vm._v(" 删除")]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAdmin == 1 && (orgInfo.levv - _vm.selfOrgInfo.levv) == 1),
        expression: "isAdmin==1 && (orgInfo.levv-selfOrgInfo.levv)==1"
      }],
      on: {
        "click": function($event) {
          return _vm.removeItem(orgInfo.customerId)
        }
      }
    }, [_vm._v(" 删除")]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAdmin == 0),
        expression: "isAdmin==0 "
      }],
      attrs: {
        "title": "不可操作"
      }
    }, [_vm._v(" 删除")]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAdmin == 1 && (orgInfo.levv - _vm.selfOrgInfo.levv) != 1),
        expression: "isAdmin==1 &&(orgInfo.levv-selfOrgInfo.levv)!=1"
      }],
      attrs: {
        "title": "不可操作"
      }
    }, [_vm._v(" 删除")])])])
  }), 0)], 1)])]), _vm._v(" "), (_vm.orgList.length > 0) ? _c('pagination', {
    attrs: {
      "pageInfo": _vm.pageInfo
    },
    on: {
      "getData": _vm.getPageNo
    }
  }) : _vm._e(), _vm._v(" "), _c('sub-page', {
    attrs: {
      "show": _vm.toShow,
      "bigTitleMsg": _vm.bigTitle,
      "scroll": _vm.scrollTop
    },
    on: {
      "cancel": _vm.handleSubPage
    }
  }, [_c('div', {
    attrs: {
      "slot": "bodycontent"
    },
    slot: "bodycontent"
  }, [(_vm.toShow) ? _c('page-organise-edit', {
    attrs: {
      "orgInfo": _vm.orgInfo,
      "curMode": _vm.keywords,
      "dispatchWeight": _vm.authRatio,
      "multiAllowable": _vm.isMultiSent,
      "curCustomerName": _vm.curCustomerName,
      "curCustomerId": _vm.curCustomerId,
      "serviceFlagSent": _vm.serviceFlagSent
    },
    on: {
      "goBackPage": _vm.handleSubPage,
      "timeToRefresh": _vm.initTable
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tab-modal', {
    ref: "modal1",
    attrs: {
      "size": "small",
      "title": "温馨提示",
      "scroll": _vm.scrollTop
    },
    on: {
      "beforeReveal": _vm.adjustPois,
      "cancel": _vm.toCloseModal
    }
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.tipContent)
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showWithdraw) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.withdrawTabBtn
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirmTabBtn
    }
  }, [_vm._v("确定")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ca3b1d4","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/organise/PageOrganiseList.vue
// module id = 1505
// module chunks = 0